import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';


import Logo from '../../assets/logo.svg';
import { ReactComponent as NavSVG1 } from '../../assets/nav/nav-1.svg';
import { ReactComponent as NavSVG4 } from '../../assets/nav/nav-4.svg';
import userImg from '../../assets/user-img.png';

import OwnerContext from '../../context/OwnerContext';


function OwnerLinksBar(props: any) {
    let { showSubMenu } = props;

    enum menuLinkActive {
        none = 0,
        consents = 1,
        help = 2,
        info = 3
    }

    enum subMenuState {
        none = 0,
        user = 1
    }

    const ownerLoginObject = useContext(OwnerContext);
    const [ activeMenu, setActiveMenu ] = useState<menuLinkActive>(menuLinkActive.consents);
    const [ showUserMenu, setShowUserMenu ] = useState<boolean>(showSubMenu);


    function setMenuState(activeLink: menuLinkActive | null, subMenu: subMenuState) {
        switch (subMenu) {
            case subMenuState.user:
                setShowUserMenu(!showUserMenu);
                break;
            default:
                setShowUserMenu(false);
        }

        if (activeLink !== null)
            setActiveMenu(activeLink);        
    }


    return (
        <div className="sidebar navbar-nav">
            <Link className="brand-logo" to="/">
                <img src={Logo} alt="Mitsamtykke Logo" />
            </Link>

            <div className="small-seperator"></div>

            <ul className="navigation">
                <li>
                    <Link className={ activeMenu === menuLinkActive.consents ? 'active' : '' } to="/consents"
                        onClick={ () => setMenuState(menuLinkActive.consents, subMenuState.none) }>
                        <NavSVG1 />
                    <div className="info-label">Dine samtykker</div>
                    </Link>
                </li>
                <li>
                    <a className={ activeMenu === menuLinkActive.help ? 'active' : '' } href="https://www.mitsamtykke.dk/support/"
                        onClick={ () => setMenuState(menuLinkActive.help, subMenuState.none) }>
                        <NavSVG4 />
                        <div className="info-label">Hj&aelig;p</div>
                    </a>
                </li>
            </ul>

            <div className="bottom">
                <div className="small-seperator"></div>
                <button className={ 'user-nav with-subnav' + (activeMenu === menuLinkActive.info ? ' active' : '' ) }
                    onClick={ () => setMenuState(null, subMenuState.user) }>
                    <div className="user-img">
                        <img src={userImg} alt="User menu" />
                    </div>
                    
                    { showUserMenu &&
                        <ul className="sub-nav">
                            <li className="with-info">
                                <p>Kontakt</p>
                                <span>{ownerLoginObject?.ownerStatus?.mobileOrEmail}</span>
                            </li>
                            <li>
                                <Link to="/">Start forfra</Link>
                            </li>
                        </ul>
                    }
                </button>
            </div>
        </div>
    )
}

export default OwnerLinksBar;
